import { takeLatest, call, all } from "redux-saga/effects";
import { getReceiverWorker } from "services/Receiver/sagas";

import { getBranchesWorker } from "../../../../services/Branch/sagas";
import { getNormalizersWorker } from "../../../../services/Normalizers/sagas";
import { getUsersWorker } from "../../../../services/Users/sagas";
import { getSourceWorker } from "../../../../services/Source/sagas";

import { initConfigManagerModule } from "./actions";

function* activeModuleWorker (){
    yield all([
        call(getUsersWorker),
        call(getReceiverWorker),
        call(getNormalizersWorker),
        call(getBranchesWorker),
        call(getSourceWorker)
    ]);
}

export function* initObjectStructures() {
    yield all([
        yield takeLatest(initConfigManagerModule, activeModuleWorker)
    ]);
}
